<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f003-01.jpg" width="80%"/></p>
<p class="caption">St Helen’s church, Burghwallis, has the largest amount of herringbone masonry of any church in South Yorkshire. This section forms part of the south wall of the nave. It dates from the eleventh century.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_chapter013.vue?1e413af2